<template>
<div class="close" @click="closeAction" :style="styleProps">
  <i class="iconfont iconguanbianniu2"></i>
</div>
</template>
<script >
export default {
  name: 'Close',
  props: {
    styleProps: {
      tyle: Object,
      default: null
    }
  },
  methods: {
    closeAction() {
      this.$emit('close');
    }
  }
};
</script>
<style lang="scss" scoped>
.close {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 11;
  cursor: pointer;
  i {
    font-size: 12px;
    color: #737596;
  } 
}
</style>



// WEBPACK FOOTER //
// src/components/common/close.vue